import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  grammarClipResponseSchema,
  grammarPointAudioSchema,
  grammarPointDetailSchema,
} from '../schemas';

const grammarItemCountsSchema = z.object({
  lesson: z.number().int().min(0),
  exam: z.number().int().min(0),
});

const getGrammarPointV1DataSchemaDefinition = z.object({
  point: grammarPointDetailSchema,
  clips: z.array(grammarClipResponseSchema),
  itemCounts: grammarItemCountsSchema,
  audio: grammarPointAudioSchema.optional(),
});

export const getGrammarPointV1DataSchema: typeof getGrammarPointV1DataSchemaDefinition =
  getGrammarPointV1DataSchemaDefinition;

export type IGetGrammarPointV1Data = z.infer<typeof getGrammarPointV1DataSchema>;

export const getGrammarPointV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarPointV1Data>> =
  createApiResponseSchema(getGrammarPointV1DataSchema) as z.ZodSchema<IAPI<IGetGrammarPointV1Data>>;

export type IGetGrammarPointV1Response = IAPI<IGetGrammarPointV1Data>;
